import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDeleteUserMutation, useGetMeQuery } from '../services/JamDB';

function Delete({ setOpen }: { setOpen: (open: boolean) => void }) {
  const [deleteUser] = useDeleteUserMutation();
  const navigate = useNavigate();

  const { data, error } = useGetMeQuery();

  // Use useEffect to close the modal if not authenticated
  useEffect(() => {
    if (
      !data ||
      (error &&
        typeof error === 'object' &&
        'status' in error &&
        (error as { status?: number }).status === 401)
    ) {
      setOpen(false);
    }
  }, [data, error, setOpen]);

  // Only render if user is authenticated
  if (
    !data ||
    (error &&
      typeof error === 'object' &&
      'status' in error &&
      (error as { status?: number }).status === 401)
  ) {
    return null;
  }

  function handleCloseDelete() {
    setOpen(false);
  }

  async function handleDelete() {
    const userId = data?.data?.userId;

    if (!userId) {
      console.error('No user ID found');
      return;
    }

    try {
      await deleteUser(userId);
      localStorage.removeItem('token');
      navigate('/');
      // window.location.reload();
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <>
      <div
        className="relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <svg
                      className="h-6 w-6 text-red-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                      />
                    </svg>
                  </div>
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <h3
                      className="text-base font-semibold leading-6 text-gray-900"
                      id="modal-title"
                    >
                      Delete account
                    </h3>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        Are you sure you want to delete your account? All of
                        your data will be permanently removed. This action
                        cannot be undone.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                  onClick={handleDelete}
                  type="button"
                  id="delete-user-btn"
                  className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                >
                  Delete
                </button>
                <button
                  id="cancel-delete-user-btn"
                  onClick={handleCloseDelete}
                  type="button"
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Delete;
